var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmsTf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 2.33334H4.66671C2.66671 2.33334 1.33337 3.33334 1.33337 5.66668V10.3333C1.33337 12.6667 2.66671 13.6667 4.66671 13.6667H11.3334C13.3334 13.6667 14.6667 12.6667 14.6667 10.3333V5.66668C14.6667 3.33334 13.3334 2.33334 11.3334 2.33334ZM11.6467 6.39334L9.56004 8.06001C9.12004 8.41334 8.56004 8.58668 8.00004 8.58668C7.44004 8.58668 6.87337 8.41334 6.44004 8.06001L4.35337 6.39334C4.14004 6.22001 4.10671 5.90001 4.27337 5.68668C4.44671 5.47334 4.76004 5.43334 4.97337 5.60668L7.06004 7.27334C7.56671 7.68001 8.42671 7.68001 8.93337 7.27334L11.02 5.60668C11.2334 5.43334 11.5534 5.46668 11.72 5.68668C11.8934 5.90001 11.86 6.22001 11.6467 6.39334Z",
    fill: "#808985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmsTf);
export default __webpack_public_path__ + "static/media/icon_smsTF.2ff2678662c97893904135cd0afcf7fa.svg";
export { ForwardRef as ReactComponent };